import React, { Component } from 'react';
import { PagerButtons, TextInput } from 'sure-components';
import PropTypes from 'prop-types';
import * as analytics from 'shared/lib/analytics';
import './RentalCarExtensionConfirmationNumber.css';

const propTypes = {
  policy: PropTypes.object,
  extensionPolicy: PropTypes.object,
  updateRentalCarExtensionConfirmationNumber: PropTypes.func,
};

const defaultProps = {
  extensionPolicy: {},
};

class RentalCarExtensionConfirmationNumber extends Component {

  componentDidMount() {
    analytics.page('Rental Car - Reservation Number - Extension');
  }

  handleUpdate = (e) => {
    this.props.updateExtensionConfirmationNumber(e.target.value);
  }

  handleNext = (e) => {
    if (e) {
      e.preventDefault();
    }

    const basePath = `/rental-car-insurance/extension/${this.props.params.policyId}`;
    this.props.navTo(`${basePath}/payment`);
  }

  render() {
    const {
      extensionPolicy,
      goBack,
    } = this.props;

    return (
      <div className="RentalCarExtensionConfirmationNumber">
        <div className="Container Container--small">
          <h1 className="RentalCarExtensionConfirmationNumber-title">
            What is your rental agreement number as shown on the rental agreement signed with the Rental Agency?
          </h1>
          <form
            className="RentalCarExtensionConfirmationNumber-form"
            autoComplete="off"
            onSubmit={this.handleNext}>
            <TextInput
              required
              name="rental_agreement_number"
              placeholder="Confirmation Number"
              onChange={this.handleUpdate}
            />
            <p className="RentalCarExtensionConfirmationNumber-helpText">
              Please note that the number you enter here must match the number shown on the original rental agreement for coverage to be effective.
            </p>
            <input
              type="submit"
              style={{display: 'none'}} />
          </form>
          <PagerButtons
            isNextDisabled={!extensionPolicy.rental_agreement_number}
            onBack={goBack}
            onNext={this.handleNext}
          />
        </div>
      </div>
    );
  }
}

RentalCarExtensionConfirmationNumber.propTypes = propTypes;
RentalCarExtensionConfirmationNumber.defaultProps = defaultProps;

export default RentalCarExtensionConfirmationNumber;
